export enum LinkVariant {
    Default = 'default',
    Inverted = 'inverted',
}
